export enum ElementTemperatureStateEnum {
  InRange,
  Mixed,
  OutOfRange,
}
